import { Injectable, inject } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';

import { ProfileStore } from '@asset-solutions/customer-portal/auth/data-access';
import { selectFilteredOrders } from '@asset-solutions/customer-portal/orders/store';
import { ComponentStore } from '@ngrx/component-store';
import { Store } from '@ngrx/store';

interface OrderSearchState {
  searchTerm: string;
}

@Injectable()
export class OrderSearchStore extends ComponentStore<OrderSearchState> {
  private readonly store = inject(Store);
  private readonly profileStore = inject(ProfileStore);

  private columns$ = toObservable(this.profileStore.orderColumns);
  private columnKeys$ = this.select(this.columns$, (columns) => columns.map((column) => column.key));

  private orders$ = this.store.select(selectFilteredOrders);
  private searchedOrders$ = this.select(this.state$, this.orders$, ({ searchTerm }, orders) => {
    if (!searchTerm) return orders;

    return orders.filter((order) =>
      `${order.tmsOrderId}^${order.shipmentDetails.bolNumber}`.toLowerCase().includes(searchTerm.toLowerCase())
    );
  });

  public tableModel$ = this.select({ columns: this.columnKeys$, orders: this.searchedOrders$ }, { debounce: true });

  public updateSearchTerm = this.updater((state, searchTerm: string): OrderSearchState => ({ ...state, searchTerm }));

  constructor() {
    super({ searchTerm: '' });
  }
}
